<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import request from '@/utils/request';
import Chart from './chart.vue';
export default {
  data () {
    return {
      cdata: []
    }
  },
  components: {
    Chart,
  },
  mounted () {
	  this.getdata()
  },
  methods: {
	  getdata(){
	  	request({
	  		url: this.$root.api + `/api/dbz/daping/dpDqfb`,
	  		method: 'get',
	  	}).then(res => {
			this.cdata = res.data
          // this.cdata=[{"code":"370702","name":"潍城区","value":59680},{"code":"370705","name":"奎文区","value":50120},{"code":"370703","name":"寒亭区","value":53258},{"code":"370704","name":"坊子区","value":45623},{"code":"370725","name":"昌乐县","value":95575},{"code":"370783","name":"寿光市","value":160565},{"code":"370724","name":"临朐县","value":98258},{"code":"370781","name":"青州市","value":95685},{"code":"370784","name":"安丘市","value":88652},{"code":"370782","name":"诸城市","value":113652},{"code":"370785","name":"高密市","value":105632},{"code":"370786","name":"昌邑市","value":75138},{"code":"370789","name":"高新区","value":65236},{"code":"370787","name":"滨海区","value":56896},{"code":"370791","name":"峡山区","value":25632}]
		})
	}
  }
}
</script>

<style lang="scss" scoped>
</style>